import * as React from 'react';
import { Box, Divider, Typography } from '@mui/material';

export const DoubleTextBlueCardStyled = ({
  title,
  heading1,
  heading2,
  label1,
  label2,
  icon,
  unit1,
  unit2
}: {
  title?: string;
  heading1: string;
  heading2?: string;
  label1: string;
  label2?: string;
  icon: any;
  unit1?: string;
  unit2?: string;
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        backgroundColor: '#004F71',
        borderRadius: '0.9375rem',
        padding: '0.9375rem'
      }}
    >
      {/* code for circle with 45px width and height with bg color as yellow */}
      <Box
        sx={{
          width: '1.8125rem',
          height: '1.8125rem',
          backgroundColor: '#004F71',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: '0.3125rem solid #FFF',
          position: 'relative',
          top: '-35px',
          padding: '0.3125rem'
        }}
      >
        <img src={icon} alt="scale" />
      </Box>

      {title && (
        <Typography
          variant="h4"
          sx={{
            fontFamily: 'BGRegular',
            fontWeight: 450,
            fontSize: '1.125rem',
            color: '#fff',
            lineHeight: '1.5rem',
            textTransform: 'uppercase',
            textAlign: 'center',
            marginBottom: '1.25rem'
          }}
        >
          {title}
        </Typography>
      )}

      <Box sx={{ display: 'block', textAlign: 'center' }}>
        {heading1 && (
          <Typography
            variant="body1"
            sx={{
              fontFamily: 'BGRegular',
              fontWeight: 450,
              fontSize: '1.125rem',
              color: '#fff',
              lineHeight: '1.5rem',
              textTransform: 'uppercase',
              textAlign: 'center'
            }}
          >
            {heading1}
          </Typography>
        )}
        {label1 && (
          <Typography
            data-testid={heading1 || 'heading1'}
            variant="body2"
            sx={{
              fontFamily: 'Calibri',
              fontWeight: 700,
              fontSize: '35px',
              color: '#fff',
              lineHeight: '3.125rem'
            }}
          >
            {label1}
            {unit1 && <span dangerouslySetInnerHTML={{ __html: unit1 }}></span>}
          </Typography>
        )}

        {label2 && (
          <Divider
            sx={{
              backgroundColor: 'rgba(255,255,255,0.4)',
              my: 2,
              width: '60%',
              mx: 'auto'
            }}
          />
        )}
        {heading2 && (
          <Typography
            variant="body1"
            sx={{
              fontFamily: 'BGRegular',
              fontWeight: 450,
              fontSize: '1.125rem',
              color: '#fff',
              lineHeight: '1.5rem',
              textTransform: 'uppercase',
              textAlign: 'center'
            }}
          >
            {heading2}
          </Typography>
        )}
        {label2 && (
          <Typography
            data-testid={heading2 || 'heading2'}
            variant="body2"
            sx={{
              fontFamily: 'Calibri',
              fontWeight: 700,
              fontSize: '35px',
              color: '#fff',
              lineHeight: '3.125rem'
            }}
          >
            {label2}
            {unit2 && <span dangerouslySetInnerHTML={{ __html: unit2 }}></span>}
          </Typography>
        )}
      </Box>
    </Box>
  );
};
